module.exports = __webpack_public_path__ + "img/TarjetaCredito.2055b5d1.png";